// import { Link } from "react-router-dom";
// import ClotaLogo from "../src/images/ClotaLogo.jpg";
// import "./Footer.css";
// import WhatsApp from "./whatsApp";
// import { ScrollTop } from "primereact/scrolltop";
// import {
//   FaFacebookF,
//   FaInstagram,
//   FaTwitter,
//   FaLinkedinIn,
//   FaWhatsapp,
// } from "react-icons/fa";
// import { BsTwitterX } from "react-icons/bs";


// function Footer() {
//   const ThisYear = new Date().getFullYear();

//   const handleFacebookClick = () => {
//     window.open("https://www.facebook.com/ClotaTech", "_blank");
//   };

//   const handleInstagramClick = () => {
//     window.open("https://www.instagram.com/ClotaTech/", "_blank");
//   };

//   const handleTwitterClick = () => {
//     window.open(
//       "https://x.com/i/flow/login?redirect_after_login=%2FClotaTech",
//       "_blank"
//     );
//   };

//   const handleLinkedInClick = () => {
//     window.open("https://www.linkedin.com/company/clota-tech/", "_blank");
//   };
//   const handleWhatsAppClick = () => {
//     const phoneNumber = "+919490384177";
//     const message = "Hello!";

//     const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
//       message
//     )}`;

//     window.open(whatsappUrl, "_blank");
//   };


//   return (
//     <>
//       <div className="">
//         <ScrollTop
//           style={{
//             position: "fixed",
//             bottom: "20px",
//             right: "20px",
//             backgroundColor: "#007bff", 
//             color: "#fff",
//             borderRadius: "50%",
//             width: "50px",
//             height: "50px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
//             cursor: "pointer",
//             zIndex: 9999,
//           }}
//         />
//       </div>
//       <WhatsApp />

//       <footer className="footer surface-900 px-5">
//         <div className="p-grid p-nogutter p-justify-between p-align-start">
         
//           <div className="p-col-12 p-md-3 footer-logo p-px-3 p-mb-5 md:p-mb-0">
//             <Link
//               to="/"
//               className="logo-link p-d-flex p-ai-center p-mb-3"
//               onClick={() => {
//                 window.scrollTo({ top: 0, behavior: "smooth" });
//               }}>
//               <img
//                 src={ClotaLogo}
//                 alt="Clota Logo"
//                 height={120}
//                 width={120}
//                 className="logo-image"
//               />
//            </Link>
//             <p className="footer-tagline">
//               It's our passion for technologies which lead us here.
//             </p>
//           </div>

//           <div className="p-col-6 p-sm-6 p-md-3 footer-section p-px-3 p-mb-2 md:p-mb-0">
//             <h5 className="footer-title">Site Links</h5>
//             <ul className="footer-list">
//               <li>
//                 <Link to="/home" className="footer-link">
//                   Home
//                 </Link>
//               </li>
//               <li>
//                 <Link to="/about" className="footer-link">
//                   About
//                 </Link>
//               </li>
//               <li>
//                 <Link to="/contact" className="footer-link">
//                   Contact Us
//                 </Link>
//               </li>
//             </ul>
//           </div>

//           <div className="p-col-6 p-sm-6 p-md-3 footer-section p-px-3 p-mb-5 md:p-mb-0">
//             <h5 className="footer-title">Quick Connect</h5>
//             <ul className="footer-list">
//               <li>
//                 <a
//                   href="mailto:support@clotatechnology.com?subject=Enquiry"
//                   className="footer-link">
//                   Email Support
//                 </a>
//               </li>
//               <li>
//                 <a
//                   href="https://www.clotatech.com"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="footer-link">
//                   Visit Us
//                 </a>
//               </li>
//             </ul>
//           </div>

//           <div className="p-col-12 p-sm-12 p-md-3 footer-section p-px-3">
//             <h5 className="footer-title">Stay In Touch</h5>
//                       <div className="social-icons mb-5">
           
//                     <FaFacebookF onClick={handleFacebookClick} />
//                     <FaInstagram onClick={handleInstagramClick} />
//                     <BsTwitterX onClick={handleTwitterClick} />
//                     <FaLinkedinIn onClick={handleLinkedInClick} />
//                     <FaWhatsapp onClick={handleWhatsAppClick} />
//           </div>
//           </div>
//         </div>

//         <div className="footer-bottom p-d-flex p-jc-between p-ai-center p-mt-6">
//           <span><b>© {ThisYear} Clota Technology - All Rights Reserved</b></span>


//         </div>
//       </footer>
//     </>
//   );
// }

// export default Footer;



// Footer.jsx
import React from "react";
import { Link } from "react-router-dom";
import { FaSquareXTwitter } from "react-icons/fa6";
import {
  FaFacebookSquare,
  FaInstagram,
  FaLinkedin,
  FaWhatsapp,
} from "react-icons/fa";
import ClotaLogoHD from "../src/images/ClotaLogo.jpg";
import WhatsApp from "./whatsApp";
import { ScrollTop } from "primereact/scrolltop";
import "./Footer.css";

const ThisYear = new Date().getFullYear();

const Footer = () => (
  <>
    <WhatsApp />
    <div className="">
      <ScrollTop
  style={{
    position: "fixed",
    bottom: "20px",
    right: "20px",
    backgroundColor: "#007bff", // Button ka color
    color: "#fff",
    borderRadius: "50%", // Circle shape
    width: "50px",
    height: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
    cursor: "pointer",
    zIndex: 9999,
  }}
/>
    </div>

    <footer className="footer">
      {/* Main Grid */}
      <div className="footer-grid">
        {/* Logo */}
        <div className="footer-col logo-col">
          <img src={ClotaLogoHD} alt="clotalogo" className="footer-logo-img" />
        </div>

        {/* About */}
        {/* <div className="footer-col">
          <h5 className="footer-heading">About Clota</h5>
          <p className="footer-text">
            Over a decade of experience and implementing best solutions in
            Database Technologies and Web Development. It's our passion for
            technologies which lead us here.
          </p>
        </div> */}

          <div className="footer-col">
          <h5 className="footer-heading">Site Link</h5>
          <Link
            to="/home"
            target="_clota"
            className="footerSubHeading"
          >
            <b>Home</b>
          </Link>
          <Link to="/about" target="_clota" className="footerSubHeading">
            <b>About Us</b>
          </Link>
          <Link to="/contact" target="_clota" className="footerSubHeading">
            <b>Contact Us</b>
          </Link>
        </div>

        {/* Community */}
        <div className="footer-col">
          <h5 className="footer-heading">Quick Connect</h5>
          <Link
            to ="mailto:support@clotatechnology.com?subject=Enquiry"
            target="_clota"
            className="footerSubHeading"
          >
            <b>Email Support</b>
          </Link>
          <Link to="https://www.clotatech.com" 
          target="_clota" className="footerSubHeading">
            <b>Visit Site</b>
          </Link>
          {/* <Link to="/ContactUsForm" target="_clota" className="footerSubHeading">
            <b>Having Queries talk to us</b>
          </Link> */}
        </div>

        {/* Get in Touch with Social Icons */}
        <div className="footer-col">
          <h5 className="footer-heading">Get in Touch</h5>
          <div className="footer-social-icons">
            <Link
              to="https://www.facebook.com/ClotaTech"
              target="_clota"
              className="social-icon facebook"
            >
              <FaFacebookSquare />
            </Link>
            <Link
              to="https://www.instagram.com/ClotaTech"
              target="_clota"
              className="social-icon instagram"
            >
              <FaInstagram />
            </Link>
            <Link
              to="https://twitter.com/ClotaTech"
              target="_clota"
              className="social-icon twitter"
            >
              <FaSquareXTwitter />
            </Link>
            <Link
              to="https://www.linkedin.com/company/clota-tech/"
              target="_clota"
              className="social-icon linkedin"
            >
              <FaLinkedin />
            </Link>
            <Link
              to="https://api.whatsapp.com/send?phone=919490384177&text=Hi, i'm enquiriying through your Clotatech Site"
              target="_clota"
              className="social-icon whatsapp"
            >
              <FaWhatsapp />
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom Bar with Terms/Privacy/CopyRight */}
      <div className="footer-legal">
        <div className="footer-copy">
          {/* <b>© {ThisYear} Clota Technology - All Rights Reserved</b> */}
          <b>
  © {ThisYear}
  <a
    href="https://www.clotatech.com/"
    target="_blank"
    rel="noopener noreferrer"
    className="ml-2 mr-2"
    style={{ color: '#0d6efd', textDecoration: 'none' }}
  >
    Clota Technology
  </a>
  - All Rights Reserved
</b>

        </div>
        {/* <div className="footer-legal-links">
          <Link to="/TermsAndCondition" target="_clota">
            <b>Terms & Condition</b>
          </Link>
          <span className="legal-divider">|</span>
          <Link to="/PrivacyPolicy" target="_clota">
            <b >Privacy Policy</b>
          </Link>
        </div> */}
      </div>
    </footer>
  </>
);

export default Footer;
